import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

import AvatarPopover from '../AvatarPopover';

const NotificationTextUser = ({ id, user }) => (
  <>
    {user.uuid ? (
      <a id={`user-name-${id}`} href="#profile" onClick={(e) => { e.preventDefault(); }}>
        {Parser(`<strong>${user.name}</strong>`)}
        {user.uuid && (
          <AvatarPopover
            user={user}
            targetId={`user-name-${id}`}
          />
        )}
      </a>
    ) : (
      user.name
    )}
    {' '}
  </>
);

NotificationTextUser.propTypes = {
  id: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default NotificationTextUser;
